import React, { Component } from "react";
import { Router, Switch, Route } from "react-router-dom";

import NavRoute from "./components/NavRoute";
import Start from "./Start/Start";
import TestnetEth from "./TestnetEth/TestnetEth.js";
import CustomToken from "./CustomToken/CustomToken";
import GetToken from "./GetToken/GetToken";
import StartDemo from "./StartDemo/StartDemo";
import Demo from "./Demo/Demo";
import Final from "./Final/Final";
import history from "./history";

const STEP_1 = "Step 1 ";
const STEP_1_TEXT = "Demo setup";

const STEP_2 = "Step 2";
const STEP_2_TEXT = "baDAPProve Demo";

const STEP_3 = "Step 3";
const STEP_3_TEXT = "Conclusion";

const SKIP_IF_YOU_HAVE_METAMASK = "I have ETH";

const SKIP_IF_CUSTOM = "I added FRT";

const SKIP_IF_FRT = "I have FRT";

export default class Routes extends Component {
  render() {
    return (
      <Router history={history} basename={process.env.PUBLIC_URL}>
        <Switch>
          <Route exact path={process.env.PUBLIC_URL + "/"} component={Start} />
          <NavRoute
            exact
            path={process.env.PUBLIC_URL + "/TestnetEth"}
            stepName={STEP_1}
            stepText={STEP_1_TEXT}
            buttonText={SKIP_IF_YOU_HAVE_METAMASK}
            buttonPath={process.env.PUBLIC_URL + "/CustomToken"}
            component={TestnetEth}
          />
          <NavRoute
            exact
            path={process.env.PUBLIC_URL + "/CustomToken"}
            stepName={STEP_1}
            stepText={STEP_1_TEXT}
            buttonText={SKIP_IF_CUSTOM}
            buttonPath={process.env.PUBLIC_URL + "/GetToken"}
            component={CustomToken}
          />
          <NavRoute
            exact
            path={process.env.PUBLIC_URL + "/GetToken"}
            buttonText={SKIP_IF_FRT}
            buttonPath={process.env.PUBLIC_URL + "/StartDemo"}
            stepName={STEP_1}
            stepText={STEP_1_TEXT}
            component={GetToken}
          />
          <NavRoute
            exact
            path={process.env.PUBLIC_URL + "/StartDemo"}
            stepName={STEP_2}
            stepText={STEP_2_TEXT}
            component={StartDemo}
          />
          <NavRoute
            exact
            path={process.env.PUBLIC_URL + "/Demo"}
            stepName={STEP_2}
            stepText={STEP_2_TEXT}
            component={Demo}
          />
          <NavRoute
            exact
            path={process.env.PUBLIC_URL + "/Final"}
            stepName={STEP_3}
            stepText={STEP_3_TEXT}
            component={Final}
          />
        </Switch>
      </Router>
    );
  }
}
